import React, { useEffect, useState } from "react";

import cn from "classnames";
import Icon from "../../../components/Icon";
import Modal from "../../../components/Modal";
import styles from "./Components.module.sass";
import Confirm from "../../../components/Confirm";
import EditCategory from "../../Category/edit";
import TemplateModal from "../../NewProduct/TemplateModal";

import { UseApi } from "../../../hooks/use-api";
import { useUser } from "../../../context";
import { ToastEmitter } from "../../../Services/assets/toast-emitter";
import { listGenerator } from "..";
import { UseDisclosure } from "../../../hooks/use-disclosure";
import { CreateCategory } from "../../Category";
import { DeleteCategory, GetCategories } from "../../../Services/lib/admin";

import category_ from "../../../i11/Category";

const CustomizeEditCategory = () => {
	const { locale } = useUser();
	const [{ isLoading, data }, getCategories] = UseApi({
		service: GetCategories,
	});

	const [category, setCategory] = useState();

	const { isOpen, onClose, onOpen } = UseDisclosure();
	const {
		isOpen: isOpenCreate,
		onClose: onCloseCreate,
		onOpen: onOpenCreate,
	} = UseDisclosure();

	const open_ = (e) => {
		onOpen();
		const { title, description, image, prior, tag, featured, _id } = e;
		setCategory({
			_id,
			title,
			description,
			image,
			prior,
			tag,
			featured,
		});
	};
	const close_ = () => {
		onClose();
		getCategories();
	};

	useEffect(() => {
		getCategories();
	}, []);
	return (
		<>
			<div className={styles.ph}>
				<div style={{ display: "flex", justifyContent: "space-between" }}>
					<div />
					<h3 style={{ marginLeft: "10rem" }}>
						{category_[locale].shop_by_cat}
					</h3>
					<button
						className={cn("button-stroke button-small", styles.button)}
						onClick={onOpenCreate}
					>
						<Icon name="add" size={24} />
						{category_[locale].add_category}
					</button>
				</div>
			</div>
			<br />

			{isLoading ? (
				<div className={cn(styles.wrap)}>
					{listGenerator(4).map((e, i) => {
						return (
							<div
								key={`_${i + 3}_`}
								className={cn(styles.busyContainer, styles.w200h300)}
							></div>
						);
					})}
				</div>
			) : (
				<div className={styles.ph}>
					<div className={styles.category}>
						<div className={cn(styles.flex)}>
							{data?.map((e, i) => {
								return (
									<CCard
										key={`_card_${i}`}
										open_={open_}
										item={e}
										getCat={getCategories}
									/>
								);
							})}
						</div>
						<div className={styles.rightButton}>
							<Icon size="24" name="arrow-next" fill="black" />
						</div>
						<div className={styles.leftButton}>
							<Icon size="24" name="arrow-down" fill="black" />
						</div>
					</div>
				</div>
			)}
			<TemplateModal visible={isOpen} onClose={close_}>
				{category && isOpen && (
					<EditCategory initial={category} close_={close_} />
				)}
			</TemplateModal>
			<TemplateModal visible={isOpenCreate} onClose={onCloseCreate}>
				{isOpenCreate && (
					<CreateCategory
						getCategories={getCategories}
						close_={onCloseCreate}
					/>
				)}
			</TemplateModal>
			<br />
			<br />
		</>
	);
};

const CCard = ({ item, open_, getCat }) => {
	const { locale } = useUser();
	const { isOpen, onClose, onOpen } = UseDisclosure();

	const [{ isLoading }, DeleteCategory_] = UseApi({
		service: DeleteCategory,
	});

	const onConfirm = async () => {
		const res = await DeleteCategory_(item._id);
		if (res) {
			ToastEmitter({
				msg: "Category deleted",
				type: "success",
			});
			getCat();
		}
	};
	return (
		<>
			<div className={cn(styles.card)}>
				<img className={styles.imageStyle} src={item.image} alt="_bannarIMG" />
				<div className={styles.textStyle}>{item.title}</div>
				<div className={styles.hoverEdit}>
					<button type="button" onClick={onOpen}>
						<Icon size="24" name="trash" fill="white" />
					</button>
					<button onClick={() => open_(item)} type="button">
						<Icon size="24" name="edit" fill="white" />
					</button>
				</div>
			</div>
			<Modal visible={isOpen} onClose={onClose}>
				<Confirm
					title={category_[locale].confirm_title}
					onCancel={onClose}
					onConfirm={onConfirm}
					isLoading={isLoading}
				/>
			</Modal>
		</>
	);
};
export default CustomizeEditCategory;
